/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Inspector_CapturedInputs */

const en_image_inspector_captured = /** @type {(inputs: Image_Inspector_CapturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Captured`)
};

const ar_image_inspector_captured = /** @type {(inputs: Image_Inspector_CapturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تاريخ الالتقاط`)
};

const bn_image_inspector_captured = /** @type {(inputs: Image_Inspector_CapturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`তোলার সময়`)
};

const de_image_inspector_captured = /** @type {(inputs: Image_Inspector_CapturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aufgenommen`)
};

const es_image_inspector_captured = /** @type {(inputs: Image_Inspector_CapturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capturada`)
};

const fr_image_inspector_captured = /** @type {(inputs: Image_Inspector_CapturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prise de vue`)
};

const pt_image_inspector_captured = /** @type {(inputs: Image_Inspector_CapturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Captura`)
};

const zh_image_inspector_captured = /** @type {(inputs: Image_Inspector_CapturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`拍摄时间`)
};

const tr_image_inspector_captured = /** @type {(inputs: Image_Inspector_CapturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Çekim tarihi`)
};

const ru_image_inspector_captured = /** @type {(inputs: Image_Inspector_CapturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Снято`)
};

const pl_image_inspector_captured = /** @type {(inputs: Image_Inspector_CapturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wykonano`)
};

/**
* | output |
* | --- |
* | "Captured" |
*
* @param {Image_Inspector_CapturedInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const image_inspector_captured = /** @type {((inputs?: Image_Inspector_CapturedInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Inspector_CapturedInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_image_inspector_captured(inputs)
	if (locale === "bn") return bn_image_inspector_captured(inputs)
	if (locale === "de") return de_image_inspector_captured(inputs)
	if (locale === "es") return es_image_inspector_captured(inputs)
	if (locale === "fr") return fr_image_inspector_captured(inputs)
	if (locale === "pt") return pt_image_inspector_captured(inputs)
	if (locale === "zh") return zh_image_inspector_captured(inputs)
	if (locale === "tr") return tr_image_inspector_captured(inputs)
	if (locale === "ru") return ru_image_inspector_captured(inputs)
	if (locale === "pl") return pl_image_inspector_captured(inputs)
	return en_image_inspector_captured(inputs)
});